'use client'

import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import Button from 'components/Button'
import ButtonLink from 'components/ButtonLink'
import Page from 'components/Page'
import ROUTES from 'config/routes.json'
import content from 'prismic-translates/common.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

interface GlobalErrorContentProps {
  onReload?: () => void
}

export default function GlobalErrorContent(props: GlobalErrorContentProps) {
  const { onReload } = props

  return (
    <Page className={classes.root}>
      <h4 className={classes.title}>{t('unexpected_error')}</h4>
      {/*For analytics purposes, do not remove*/}
      <span style={{ display: 'none' }} id={'analytics_error_page'}></span>

      <div>
        <ButtonLink variant='contained' className={classes.btn} href={ROUTES.HOME}>
          {t('go_to_home_btn')}
        </ButtonLink>

        {onReload && (
          <Button variant='outlined' className={classes.btn} onClick={onReload}>
            {t('reload_page_btn')}
          </Button>
        )}
      </div>
    </Page>
  )
}
